/* ════════════════════════════════════════════════════════════
   AMSX-Analytix — Constants
   Extracted from index.jsx — Tier 1 + Tier 2 split
   ──────────────────────────────────────────────────────────── */

export var MONTH_S = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

export var MONTH_N = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export var ALL_MEASURES = ["Unit","USD","LC","Price","Patients","Prescriptions"];

export var FEAT_LBL = {country:"Country",sector:"Sector",manufacturer:"Manufacturer",medicine:"Product Name",sku:"SKU",
  agent:"Agent",atc1:"ATC 1",atc2:"ATC 2",atc3:"ATC 3",atc4:"ATC 4",molecule:"Molecule",
  region:"Region",governorate:"Governorate",
  continent:"Continent",subContinent:"Sub-Continent",countryOfOrigin:"Country of Origin",manufacturerType:"Manufacturer Type",localImported:"Local / Imported",
  subManufacturer:"Sub-Manufacturer",subProduct:"Sub-Product",productSource:"Product Source",
  orderNo:"Order No",tenderStatus:"Tender Status",nfc:"NFC",nfc2:"NFC 2",nfc3:"NFC 3",
  form:"Form",pack:"Pack Size",strength:"Strength",aloneCombined:"Alone/Combined",
  docRegion:"Doc Region",docSpec:"Doc Spec",docCity:"Doc City",
  phRegion:"Ph. Region",phCity:"Ph. City",
  patientAge:"Patient Age",patientGender:"Patient Gender",diagnosis:"Diagnosis"};

export var HIER = ["country","sector","atc1","atc2","atc3","atc4","molecule","nfc","nfc2","nfc3","agent","manufacturer","subManufacturer","medicine","subProduct","productSource","sku","form","pack","strength","aloneCombined","region","governorate","docRegion","docSpec","docCity","phRegion","phCity","patientAge","patientGender","diagnosis","continent","subContinent","countryOfOrigin","manufacturerType","localImported","orderNo","tenderStatus"];

export var FIELD_DEFS = [
  {key:"country",    label:"Country",       req:false, hint:"e.g. Jordan, Egypt"},
  {key:"sector",      label:"Sector",        req:true,  hint:"e.g. Public / Private"},
  {key:"manufacturer",label:"Manufacturer",  req:false, hint:"Company / lab name"},
  {key:"medicine",    label:"Product",        req:false, hint:"Product or brand"},
  {key:"sku",         label:"SKU",            req:false, hint:"Pack / presentation"},
  {key:"agent",       label:"Agent",          req:false, hint:"Distributor"},
  {key:"atc1",        label:"ATC 1",          req:false, hint:"ATC level 1"},
  {key:"atc2",        label:"ATC 2",          req:false, hint:"ATC level 2"},
  {key:"atc3",        label:"ATC 3",          req:false, hint:"ATC level 3"},
  {key:"atc4",        label:"ATC 4",          req:false, hint:"ATC level 4"},
  {key:"molecule",    label:"Molecule",        req:false, hint:"INN / active substance"},
  {key:"region",      label:"Region",          req:false, hint:"e.g. North, South, Central"},
  {key:"governorate", label:"Governorate",     req:false, hint:"e.g. Baghdad, Basra, Erbil"},
  {key:"continent",       label:"Continent",          req:false, hint:"e.g. Asia, Europe"},
  {key:"subContinent",    label:"Sub-Continent",      req:false, hint:"e.g. Middle East"},
  {key:"countryOfOrigin", label:"Country of Origin",  req:false, hint:"Manufacturer origin country"},
  {key:"manufacturerType",   label:"Manufacturer Type",  req:false, hint:"e.g. Generic, Originator"},
  {key:"localImported",    label:"Local / Imported",   req:false, hint:"e.g. Local, Imported"},
  {key:"yearCol",     label:"Year Column",     req:false, hint:"Numeric year e.g. 2024"},
  {key:"quarterCol",  label:"Quarter Column",  req:false, hint:"1-4 or Q1-Q4"},
  {key:"monthCol",    label:"Month Column",    req:false, hint:"1-12 or Jan-Dec"},
  {key:"units",       label:"Unit",           req:false, hint:"Sales volume"},
  {key:"valLC",       label:"Value LC",       req:false, hint:"Local currency value"},
  {key:"valUSD",      label:"Value USD",      req:false, hint:"USD value"},
  {key:"priceLC",     label:"Unit Price LC",   req:false, hint:"e.g. UnitPriceLC"},
  {key:"priceUSD",    label:"Unit Price USD",  req:false, hint:"e.g. UnitPriceUSD"},
];

export var EMPTY_SEL = {
  country:[], sector:[], manufacturer:[], medicine:[], sku:[], agent:[],
  region:[], governorate:[],
  continent:[], subContinent:[], countryOfOrigin:[], manufacturerType:[], localImported:[],
  subManufacturer:[], subProduct:[], productSource:[],
  orderNo:[], tenderStatus:[],
  /* Medical dimensions */
  form:[], pack:[], strength:[], aloneCombined:[],
  docRegion:[], docSpec:[], docCity:[],
  phRegion:[], phCity:[],
  patientAge:[], patientGender:[],
  diagnosis:[],
  atcFilters:{ATC1:[],ATC2:[],ATC3:[],ATC4:[],MOLECULE:[]},
  nfcFilters:{NFC:[],NFC2:[],NFC3:[]},
  periodMode:"", periodKeys:[],
  measures:[], showCols:[],
  stats:{ indicators:[], growthMode:"prev" },
  topN:{ enabled:false, n:10, measure:"Unit", applyTo:"top", mode:"global", dims:[], showOthers:false },
};

/* ── Dashboard chart palette ── */
export var DASH_COLORS  = ["#1A3F6E","#23548E","#2D6BA8","#5A9AD2","#78B2E0","#0F6E56","#148868","#1BA878","#38B48C","#6DD8B2"];
export var DASH_COLORS2 = ["#1A3F6E","#23548E","#2D6BA8","#5A9AD2","#78B2E0","#0F6E56","#148868","#1BA878","#38B48C","#6DD8B2"];

/* ── Logo asset path (served as static file from /public) ── */
export var AMSX_LOGO = "/logo.png";

/* ── Tier 2 promoted constants (referenced by FilterPanel + AdminPanel) ── */
export var SECTOR_TYPES = ["Private","Public"];

export var DIMENSION_KEYS = ["country","sector","manufacturer","subManufacturer","medicine","subProduct","productSource","sku","agent","atc1","atc2","atc3","atc4","molecule","nfc","nfc2","nfc3","region","governorate","continent","subContinent","countryOfOrigin","manufacturerType","localImported","orderNo","tenderStatus","form","pack","strength","aloneCombined","docRegion","docSpec","docCity","phRegion","phCity","patientAge","patientGender","diagnosis"];
